import { render, staticRenderFns } from "./CreateStoreProduct.vue?vue&type=template&id=0dfe82e1&scoped=true"
import script from "./CreateStoreProduct.vue?vue&type=script&lang=js"
export * from "./CreateStoreProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfe82e1",
  null
  
)

export default component.exports